import LockSVG from "../../content/img/lock.svg";
import { useEffect, useState } from "react";
import { useAuth } from "oidc-react";
import { useNavigate } from "react-router-dom";
import useValidateSubscription from "../../hooks/useValidateSubscription";
import { useTranslation } from "react-i18next";
import { Button } from "@etframework/ui.components";

export const InvalidLicense = () => {
  const { t } = useTranslation(["errorPages"]);
  const { userManager } = useAuth();
  const [token, setToken] = useState(null);
  const navigate = useNavigate();
  const prodId = import.meta.env.PUBLIC_DUEDATES_PRODUCT_ID;

  const hasValidSubscription = useValidateSubscription(token, prodId);

  const refreshAccessToken = async () => {
    try {
      const refreshedUser = await userManager.signinSilent();
      setToken(refreshedUser.access_token);
    } catch (error) {
      console.error("Error refreshing token:", error);
    }
  };

  useEffect(() => {
    if (token !== null && hasValidSubscription) {
      sessionStorage.setItem("valid_sub", hasValidSubscription);
      sessionStorage.setItem("token", token);
      navigate(`/duedates/views/assignedtome`);
    }
  }, [token, hasValidSubscription, navigate]);

  return (
    <div className="error-page-container">
      <img
        src={LockSVG}
        alt="Error illustration"
        className="error-image unauthorized"
        style={{ width: "130px" }}
      />
      <h1 className="error-title">{t("InvalidLicense.title")}</h1>

      <p className="error-message">{t("InvalidLicense.message")}</p>
      <div className="mt-4">
        <Button onClick={refreshAccessToken}>{t("TryAgain")}</Button>
      </div>
    </div>
  );
};
